import { LS } from '@cyboticx/common';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

const interceptorResponseFn = (response: AxiosResponse<any>): AxiosResponse<any> => response;

const interceptorErrorFn = (error: any) => {
	if (error.response) {
		const status = error.response.status;

		if (status === 401) {
			LS.removeAccessToken();

			// alert("error 401 alert")
			window.location.reload();

			return Promise.reject({
				status,
				payload: {},
				list: [{ msg: 'Unauthorized Error' }],
			});
		}

		if (status === 400) {
			if ('data' in error.response && 'validation' in error.response.data) {
				return Promise.reject({
					status,
					payload: {},
					list: [{ msg: error.response.data.validation.body.message }],
				});
			}

			return Promise.reject({
				status,
				payload: {},
				list: [{ msg: 'Bad Request' }],
			});
		}

		if (status === 403) {
			return Promise.reject({
				status,
				payload: {},
				list: [{ msg: 'Forbidden' }],
			});
		}

		const response = {
			status: error.response.status,
			payload: error.response.data && error.response.data.payload ? error.response.data.payload : {},
			list: error.response.data.errors,
		};
		return Promise.reject(response);
	} else {
		const response = {
			status: 500,
			payload: {},
			list: [{ msg: 'Something went wrong.' }],
		};
		return Promise.reject(response);
	}
};

class API {
	private readonly BASE_URL: string = `${process.env.REACT_APP_API_URL!}/api/v1`;
	private readonly axiosInstance: AxiosInstance;

	constructor() {
		const config: AxiosRequestConfig = { baseURL: this.BASE_URL };
		this.axiosInstance = axios.create(config);
		this.axiosInstance.interceptors.response.use(interceptorResponseFn, interceptorErrorFn);

		this.addAccessToken(LS.readAccessToken());
	}

	public urlPath = this.BASE_URL;

	public addAccessToken = (token?: string) => {
		this.axiosInstance.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : '';
	};

	public removeAccessToken = () => {
		this.axiosInstance.defaults.headers.common['Authorization'] = '';
	};

	public url = (path: string) => {
		if (path.startsWith('/')) return `${this.BASE_URL}${path}`;
		else return `${this.BASE_URL}/${path}`;
	};

	public get client() {
		return this.axiosInstance;
	}

	public get = <IRequest, IResponse>(url: string, config?: AxiosRequestConfig<any>) => {
		return this.axiosInstance.get<IRequest, AxiosResponse<IResponse>>(url, config);
	};

	public post = <IRequest, IResponse>(url: string, payload: IRequest) => {
		return this.axiosInstance.post<IRequest, AxiosResponse<IResponse>>(url, payload);
	};

	public put = <IRequest, IResponse>(url: string, payload: IRequest) => {
		return this.axiosInstance.put<IRequest, AxiosResponse<IResponse>>(url, payload);
	};

	public delete = <IRequest, IResponse>(url: string) => {
		return this.axiosInstance.delete<IRequest, AxiosResponse<IResponse>>(url);
	};
}

export default new API();
